import React, { useMemo } from 'react';
import { Card, Space, Tag, Typography } from 'antd';
import { buildCardView } from './cardStats';
import { buildCurveSeries } from './curveSeries';
import { MY_TEAM_INDEX } from './liveAssistState';
import { SERIES_COLORS } from './PipTeamsView';
import PowerCurveSvg from './PowerCurveSvg';
import usePowerCurves, { powerCurveKey } from './usePowerCurves';

/**
 * 게임 중 웹 왼쪽 위에 항상 켜 두는 "우리 팀 파워 커브". 우리 팀(MY_TEAM_INDEX, 조합 창 맨 위 1팀)의 3명 곡선을 한 그래프에 겹쳐 그리고,
 * 지금 일차/낮밤 구간을 강조한다. 파워 커브는 PiP와 같은 공유 저장소를 써서 같은 조합을 다시 요청하지 않는다.
 * - teams: 조합 인식 결과(없으면 안내 문구)
 */
export default function MyTeamCurveCard({ teams, topRanker, currentPhase }) {
  const team = teams ? teams[MY_TEAM_INDEX] : null;
  const views = useMemo(
    () => (team ? team.map((card) => buildCardView(card, topRanker.stats, topRanker.totalGameCount, topRanker.averages)) : []),
    [team, topRanker.stats, topRanker.totalGameCount, topRanker.averages]
  );
  const curves = usePowerCurves(views.map((v) => ({ characterName: v.characterName, weaponName: v.weaponName })));
  const curveOf = (v) => curves[powerCurveKey(v.characterName, v.weaponName)] || { status: 'loading', points: [] };
  const series = buildCurveSeries({ views, curveOf, colors: SERIES_COLORS });
  const loading = views.some((v) => curveOf(v).status === 'loading');

  return (
    <Card size="small" title="우리 팀 파워 커브">
      {views.length === 0 ? (
        <Typography.Text type="secondary">
          게임 시작 전에 조합 창에서 [조합 캡처]를 하면 우리 팀 파워 커브가 여기에 항상 표시돼요.
        </Typography.Text>
      ) : (
        <>
          <div style={{ background: '#fff', borderRadius: 6, minHeight: 120 }}>
            {loading && !series.some((s) => s.points.length) ? (
              <div style={{ padding: 40, textAlign: 'center', color: '#8c8c8c', fontSize: 13 }}>파워 커브 불러오는 중…</div>
            ) : (
              <PowerCurveSvg series={series} current={currentPhase} showIcons />
            )}
          </div>
          <Space size={[14, 4]} wrap style={{ marginTop: 8 }}>
            {views.map((view, i) => (
              <span key={`${view.characterName}-${i}`} style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                <span
                  style={{
                    display: 'inline-block', width: 18, borderTop: `3px solid ${SERIES_COLORS[i % SERIES_COLORS.length]}`, verticalAlign: 'middle', marginRight: 6,
                  }}
                />
                <b>{view.characterName}</b>
                {view.weaponName && <Typography.Text type="secondary"> {view.weaponName}</Typography.Text>}
                {view.weaponEstimated && <Tag color="gold" style={{ marginLeft: 4 }}>무기 추정</Tag>}
                {view.lowConfidence && <Tag color="gold" style={{ marginLeft: 4 }}>확인 필요</Tag>}
              </span>
            ))}
          </Space>
        </>
      )}
    </Card>
  );
}
